/**
 * @generated SignedSource<<c50266f7de3832a475c7273391f7906a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "poolsRequest"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "poolticksRequest"
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "request",
        "variableName": "poolticksRequest"
      }
    ],
    "concreteType": "Page_Pooltick",
    "kind": "LinkedField",
    "name": "recurringPoolticksByViewer",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Pooltick",
        "kind": "LinkedField",
        "name": "content",
        "plural": true,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "request",
        "variableName": "poolsRequest"
      }
    ],
    "concreteType": "Page_Pool",
    "kind": "LinkedField",
    "name": "poolsByViewer",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Pool",
        "kind": "LinkedField",
        "name": "content",
        "plural": true,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "cardPan",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "cardType",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "paymentMethodSyncPoolticksQuery",
    "selections": (v3/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "paymentMethodSyncPoolticksQuery",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "37e5c9730f34d8622aeca136b49c51f8",
    "id": null,
    "metadata": {},
    "name": "paymentMethodSyncPoolticksQuery",
    "operationKind": "query",
    "text": "query paymentMethodSyncPoolticksQuery(\n  $poolticksRequest: RecurringPoolticksRequestInput\n  $poolsRequest: PoolsRequestInput\n) {\n  recurringPoolticksByViewer(request: $poolticksRequest) {\n    content {\n      id\n    }\n  }\n  poolsByViewer(request: $poolsRequest) {\n    content {\n      id\n      cardPan\n      cardType\n    }\n  }\n}\n"
  }
};
})();

node.hash = "dc7ddf26caba06b4b6b59f43f2332009";

module.exports = node;
